<template>
  <div class="fullEditor">
    <div class="mx-4 mb-3 d-flex">
      <div class="step_number_circle"><span>1</span></div> Please Copy and Paste the information from the
      <a class="fw-600 text-main mx-1" href="https://travcorp.sharepoint.com/:f:/s/Global/Teams/Groups/EnAUdT6VqIxEnmtJ6-zqmSwBn_TMZmsaQhNobeS7Hz0pcg?e=nl38oc" target="_blank">template of introduction</a>
      to be added into the Guest Documentation
      <BaseLabelWithPopover width="200px">
          <h6>Template of infomation</h6>
        </BaseLabelWithPopover>
    </div>
    <Editor
      v-model="$v[validationGroupName].guestDocumentation.introduction.$model"
      @blur="$v[validationGroupName].guestDocumentation.introduction.$touch()"
      :validator="$v[validationGroupName].guestDocumentation.introduction"
      :showDebugger="false"
      :disabled="isCompletedQuote" />
  </div>
</template>

<script>
import Editor from '@/components/_shared/Editor.vue'

export default {
  name: 'TabIntroduction',
  inject: ['$v'],
  components: { Editor },
  props: {
    validationGroupName: {
      type: String,
      required: true
    },
    isCompletedQuote: {
      type: Boolean,
      required: false
    }
  }
}
</script>
